import type { LibraryEntry } from "../api/contract";

export type PanelTab = "section" | "comments" | "chat";
export type PersistentPanelTab = Exclude<PanelTab, "section">;

export function panelTabs(mode: "simple" | "advanced", selected: boolean): PanelTab[] {
  return mode === "advanced" ? [...(selected ? ["section" as const] : []), "comments", "chat"] : ["chat"];
}

export function fallbackPanelTab(tab: string | null): PersistentPanelTab {
  return tab === "comments" ? "comments" : "chat";
}

export function sectionActionNote(action: "hide" | "up" | "down" | "remove"): string {
  return {
    hide: "Hide this section.",
    up: "Move this section above the one before it.",
    down: "Move this section below the one after it.",
    remove: "Remove this section.",
  }[action];
}

/** Entries that are bound inside the selected preview node, in library order. */
export function entriesForBinds(entries: LibraryEntry[], binds: readonly string[]): LibraryEntry[] {
  const wanted = new Set(binds);
  return entries.filter((entry) => wanted.has(entry.id));
}

export function listOrders(entries: LibraryEntry[]): Map<string, string[]> {
  const orders = new Map<string, string[]>();
  for (const entry of entries) {
    if (!entry.list) continue;
    if (!orders.has(entry.list.collectionId)) orders.set(entry.list.collectionId, Array(entry.list.count).fill(""));
    orders.get(entry.list.collectionId)![entry.list.index] = entry.id;
  }
  return orders;
}
